module.exports = __webpack_public_path__ + "media/images/icons/icon-copy-792bc48358a44db12db311235d392183.svg";